<template>
  <Default>
    <router-view :key="route.meta.bodyOnly ? route.path : undefined" />
  </Default>
</template>

<script setup>
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import Default from './layouts/Default.vue'
import { hasAllPermissions } from './auth/authorization'
import { useMsal } from './auth/useMsal'

const route = useRoute()
const router = useRouter()
const { permissions } = useMsal()

defineOptions({
  name: 'App',
})

watch(
  () => permissions.value?.permissions,
  enforceCurrentRouteAuthorizationAsync,
  { deep: true }
)

async function enforceCurrentRouteAuthorizationAsync () {
  if (!permissions.value || route.name === 'forbidden') {
    return
  }

  const requiredPermissions = route.matched.flatMap((matchedRoute) => (
    matchedRoute.meta.requiredPermissions ?? []
  ))

  if (hasAllPermissions(requiredPermissions)) {
    return
  }

  try {
    await router.replace({ name: 'forbidden' })
  } catch (error) {
    console.error('Failed to leave a route after authorization changed.', error)
  }
}
</script>
